import { styled } from '@mui/material/styles';

const StyledTextArea = styled('textarea')(({ theme }) => ({
  width: '100%',
  minHeight: '150px',
  padding: '16px',
  borderRadius: '4px',
  fontFamily: 'inherit',
  fontSize: 'inherit',
  resize: 'vertical',
  border: '1.5px solid #E0E0E0',
  outline: 'none',
  '&:focus': {
    borderColor: theme.palette.primary.main,
    borderWidth: '2px'
  },
}));

export default StyledTextArea;